import { call, put, all, takeLatest, select } from 'redux-saga/effects';
import { PersonalizacaoService } from '@services';
import {
  recuperaPersonalizacaoSuccess,
  alterarPersonalizacaoSuccess,
} from './actions';
import {
  ALTERA_PERSONALIZACAO_REQUEST,
  RECUPERA_PERSONALIZACAO_REQUEST,
} from './constants';

function* recuperaPersonalizacaoSistema({ values }) {
  const { token } = yield select((state) => state.user);
  const service = new PersonalizacaoService();
  const personalizacao = yield call(
    service.getPersonalizacaoHome,
    values.matricula,
    values.plano,
    token
  );
  yield put(recuperaPersonalizacaoSuccess(personalizacao));
}

function* alteraPersonalizacaoSistema({ values }) {
  const { token } = yield select((state) => state.user);
  const service = new PersonalizacaoService();
  const setPersonalizacao = yield call(
    service.setPersonalizacaoHome,
    values.matricula,
    values.plano,
    values.preferencias,
    token
  );
  if (setPersonalizacao === 1) {
    const getPersonalizacao = yield call(
      service.getPersonalizacaoHome,
      values.matricula,
      values.plano,
      token
    );

    yield put(alterarPersonalizacaoSuccess(getPersonalizacao));
  }
}

export default all([
  takeLatest(ALTERA_PERSONALIZACAO_REQUEST, alteraPersonalizacaoSistema),
  takeLatest(RECUPERA_PERSONALIZACAO_REQUEST, recuperaPersonalizacaoSistema),
]);
